<style lang="less">
.component{

}
</style>

<template>
	<!-- Main component -->
	<section class="component">

	</section>
</template>

<script>
	/*
		global track
	*/
	import android from '@flyme/jr/js/android.js';

	import axios from '../axios.js';
	import apis from '../apis.js';

	export default {
		data: function () {
			return {
			};
		},
		components: {
		},
		created: function () {
			android('startLoading', {mes: '正在加载'});
		},
		mounted: function () {
			this.getDetail();
			// this.$router.replace({ path: 'canvas' });
		},
		methods: {
			getDetail: function () {
				let _this = this;
				axios.post(apis.acct_query, {
					show_type: 0
				}).then(function(d) {
					if (d.value.acct_account_info && d.value.acct_account_info.avaliable_bal) {
						d.value.acct_account_info.money = d.value.acct_account_info.avaliable_bal.Format();
					}
					if (d.value.acctplus_account_info && d.value.acctplus_account_info.avaliable_asset) {
						d.value.acctplus_account_info.money = d.value.acctplus_account_info.avaliable_asset.Format();
					}
					if (d.value.acct_status === 0) {
						// 未开通
						_this.$router.replace({ path: 'guide', query: {acct_query: JSON.stringify(d.value) }  });
						track('event_account_info', {
							status: 0
						});
					}else if (d.value.acct_status === 1){
						// 仅开通余额
						_this.$router.replace({ path: 'account', query: {acct_query: JSON.stringify(d.value) }  });
						track('event_account_info', {
							status: 1
						});
					}else if (d.value.acct_status === 2){
						// 开通余额和余额+
						_this.$router.replace({ path: 'acctplus', query: {acct_query: JSON.stringify(d.value) } });
						track('event_account_info', {
							status: 2
						});
					}
				});
			},

		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Loading.vue